import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "contact-box"
}
const _hoisted_2 = { lang: "en" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "contact-box"
}
const _hoisted_6 = { lang: "en" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { lang: "en" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RhButton = _resolveComponent("RhButton")!
  const _component_ImageTeaser = _resolveComponent("ImageTeaser")!

  return (_openBlock(), _createBlock(_component_ImageTeaser, {
    class: "contact",
    footerContactFormIsVisible: _ctx.contactFormIsVisible
  }, {
    image: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", {
        class: "footer-contact-image",
        alt: ""
      }, null, -1)
    ]))]),
    default: _withCtx(() => [
      (!_ctx.contactFormIsVisible && !_ctx.isCurrentLocaleGerman)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("general.contact")), 1),
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("contactForm.companyName")), 1),
            _createElementVNode("address", {
              innerHTML: _ctx.$t('contactForm.address')
            }, null, 8, _hoisted_3),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("footerContact.openingHours")), 1),
              _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("footerContact.mondayToFriday")), 1),
              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("footerContact.time")), 1)
            ]),
            _createElementVNode("address", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("footerContact.telephone")) + " ", 1),
              _createElementVNode("a", {
                href: 'tel:' + _ctx.$t('footerContact.phoneNumber')
              }, _toDisplayString(_ctx.$t("footerContact.phoneNumber")), 9, _hoisted_4)
            ]),
            (_ctx.$route.name !== 'contact')
              ? (_openBlock(), _createBlock(_component_RhButton, {
                  key: 0,
                  value: _ctx.$t('footerContact.establishContact'),
                  priority: "ghost",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$navigateTo('contact')))
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCurrentLocaleGerman)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("general.contact")), 1),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("contactForm.companyName")), 1),
            _createElementVNode("address", {
              innerHTML: _ctx.$t('contactForm.address')
            }, null, 8, _hoisted_7),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("footerContact.deliveryStatusQuestion")), 1),
            _createElementVNode("a", {
              class: "link2",
              href: _ctx.getLink()
            }, _toDisplayString(_ctx.$t("footerContact.redirectLoginPage")), 9, _hoisted_8),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("footerContact.moreQuestions")) + " ", 1),
              _cache[5] || (_cache[5] = _createElementVNode("a", {
                class: "link2",
                href: "/de/faq",
                lang: "en"
              }, "FAQs", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("footerContact.contactCustomerService")) + " ", 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("footerContact.clientAndCustomerCareCenter")), 1)
            ]),
            (_ctx.$route.name !== 'contact')
              ? (_openBlock(), _createBlock(_component_RhButton, {
                  key: 0,
                  value: _ctx.$t('footerContact.establishContact'),
                  priority: "ghost",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$navigateTo('contact')))
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["footerContactFormIsVisible"]))
}